import { createContext } from 'react'

export type HybridTeaserContextType = true

const HybridTeaserContext = createContext<HybridTeaserContextType | undefined>(
  undefined
)

export default HybridTeaserContext
